var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 9.08333L19.875 5.625C19.5 5.25 19 5 18.5 5H9.95833C8.875 5.04167 8 5.91667 8 7.04167V24.375C8 25.4583 8.875 26.3333 9.95833 26.3333H21.9583C23.0833 26.3333 24 25.4583 24 24.375V10.5C24 10 23.75 9.45833 23.375 9.08333ZM18.625 7.16667L21.8333 10.375H18.625V7.16667ZM22 24.375H9.95833V7.04167H16.625V11.375C16.625 11.9167 17.0833 12.375 17.625 12.375H22V24.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5237C12 19.5237 13.7517 19.2625 14.5 18.5237C15.1214 17.9102 15.8011 16.9184 16 16.0236C16.1694 15.2611 15.9366 14.9603 15.5 14.5237C15.0634 14.0871 14.6113 13.9364 14 14.0237C13.0335 14.1618 12.5 15.5239 12.5 16.0237C12.5 16.5235 12.6686 17.5848 13 18.5237C13.2906 19.3471 13.4142 20.5237 14 20.5237C14.5858 20.5237 14.9142 20.5237 15.5 20.5237C16.0858 20.5237 17 18.5237 17 18.5237C17 18.5237 17.4477 17.5237 18 17.5237C18.5523 17.5237 18.4584 18.4154 19 18.5237C19.6904 18.6618 20.5 17.5237 20.5 17.5237",
    fill: "#F15A29",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedContract);
export default __webpack_public_path__ + "static/media/Selected Contract.0de65ac4d598daf6d56a5ac35a1e8753.svg";
export { ForwardRef as ReactComponent };